import { bootstrapApp } from './bootstrap/bootstrapApp';

const MAX_BOOTSTRAP_RETRIES = 40;
const BOOTSTRAP_RETRY_DELAY_MS = 100;

function startApp(attempt = 0) {
  try {
    bootstrapApp();
  } catch (error) {
    if (error?.message?.includes('Root element not found') && attempt < MAX_BOOTSTRAP_RETRIES) {
      window.setTimeout(() => startApp(attempt + 1), BOOTSTRAP_RETRY_DELAY_MS);
      return;
    }
    throw error;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startApp, { once: true });
} else {
  startApp();
}
